/*
 * DownloadButton: a link that saves what a route serves as a file.
 *
 * An anchor rather than a fetch: the browser sends the session cookie on a
 * same-origin navigation, writes the body straight to disk and names the file
 * from the response, all of which a fetch into memory would have to redo.
 *
 * ! file components/DownloadButton.js
 * ---------------
 * \author: Tolga O. Atalay
 * \Affiliation: A2 Labs LLC / A12XT Inc.
 * \date: 2026
 */

import React from "react";

export default function DownloadButton({ href, label, filename, title }) {
  if (!href) return null;
  return (
    <a
      href={href}
      download={filename || true}
      title={title}
      style={{
        textDecoration: "none",
        fontSize: "0.72rem",
        fontWeight: 600,
        color: "#1e40af",
        background: "#eff6ff",
        border: "1px solid #bfdbfe",
        borderRadius: 6,
        padding: "0.3rem 0.6rem",
        whiteSpace: "nowrap",
      }}
    >
      ⤓ {label}
    </a>
  );
}
